import { useEffect, useState } from "react"
import MarkdownBoldTextarea from "./MarkdownBoldTextarea"

interface SectionTextEditModalProps {
  open: boolean;
  onClose: () => void;
  sectionLabel: string;
  initialText: string;
  onSave: (text: string) => void;
}

export default function SectionTextEditModal({ open, onClose, sectionLabel, initialText, onSave }: SectionTextEditModalProps) {
  const [text, setText] = useState<string>(initialText)

  useEffect(() => {
    if (open) {
      setText(initialText)
    }
  }, [open, initialText])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      <button
        type="button"
        className="absolute inset-0 bg-black/60 border-0 cursor-default"
        aria-label="Close dialog backdrop"
        onClick={onClose}
      />
      <div className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full mx-6 max-h-[90vh] flex flex-col">
        <div className="px-5 py-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Edit section</h3>
          <p className="text-sm text-gray-600 mt-1">{sectionLabel}</p>
          <p className="text-xs text-gray-500 mt-2">
            Use <code>**bold**</code> or <code>*italic*</code> to format text. Shortcuts:{" "}
            <kbd className="px-1 bg-gray-100 rounded">Ctrl</kbd>+<kbd className="px-1 bg-gray-100 rounded">B</kbd>{" "}
            for bold,{" "}
            <kbd className="px-1 bg-gray-100 rounded">Ctrl</kbd>+<kbd className="px-1 bg-gray-100 rounded">I</kbd>{" "}
            for italic.
          </p>
        </div>
        <div className="px-5 py-3 flex-1 overflow-y-auto flex flex-col gap-3 min-h-0">
          <MarkdownBoldTextarea value={text} onChange={setText} minHeight={160} placeholder="" />
        </div>
        <div className="px-5 py-4 border-t border-gray-200 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => {
              onSave(text)
              onClose()
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  )
}
